import type { AppColors } from "@1js/acui-common";

import type { SelectedPivotIndicatorStyles } from "./SelectedPivotIndicator.styles";

export interface SelectedPivotIndicatorProps {
  /**
   * The custom app colors used to style the pivot indicator
   */
  appColors?: AppColors;

  /**
   * The position of the pivot indicator
   */
  position: number;

  /**
   * The offset of the pivot indicator
   */
  offset?: number;

  /**
   * The length of the pivot indicator in pixels
   */
  length: number;

  /**
   * Thickness of the indicator in pixels
   * Defaults to 3
   */
  thickness?: number;

  /**
   * True if the indicator should animate from it's previous state to the next
   */
  showAnimation: boolean;

  /**
   * Direction of the indicator
   * Default to Horizontal
   */
  direction?: SelectedPivotIndicatorDirection;

  /**
   * Custom styles for the pivot indicator
   */
  styles?: SelectedPivotIndicatorStyles;

  /**
   * Temporary prop, T/F if the new styles should be used when the flight is on
   * This is because Ribbon components like TabList, Pivot, etc are used outside of the Ribbon
   */
  useNextStyles?: boolean;

  /**
   * Flag to indicate if the borders should be rounded
   */
  isTabIndicatorRounded?: boolean;
}

export enum SelectedPivotIndicatorDirection {
  Horizontal,
  Vertical,
}

export const selectedPivotIndicatorId = "selectedPivotIndicator";
